exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ReceivingModalView .modal-dialog[data-v-3c5dfeac]{min-width:80%}#ReceivingApprovalModal .modal-dialog[data-v-3c5dfeac]{min-width:90%}.table-wrapper[data-v-3c5dfeac]{overflow-x:auto;overflow-y:hidden}", ""]);

// exports
